(function () {
    'use strict';

    var roots = document.querySelectorAll('[data-ukpr-polls-sidebar]');
    if (!roots.length) return;

    var PARTY_META = {
        reform: { label: 'REFORM', color: '#26C6DA', text: '#1d1d1d' },
        lab:    { label: 'LAB',    color: '#FF1744', text: '#ffffff' },
        con:    { label: 'CON',    color: '#1E88E5', text: '#ffffff' },
        lib:    { label: 'LD',     color: '#F6A800', text: '#1d1d1d' },
        snp:    { label: 'SNP',    color: '#F2D232', text: '#1d1d1d' },
        green:  { label: 'GRN',    color: '#5AD313', text: '#1d1d1d' },
        plaid:  { label: 'PC',     color: '#3F8428', text: '#ffffff' },
        other:  { label: 'OTH',    color: '#BDBDBD', text: '#1d1d1d' }
    };

    var PARTY_KEYS = ['reform', 'lab', 'con', 'lib', 'snp', 'green', 'plaid', 'other'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Poll bar reveal durations/delays in ms — all bars finish at exactly 1500 ms.
    var DURATIONS = [1500, 1200, 900, 600];
    var DELAYS    = [0, 300, 600, 900];

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function fmtDate(str) {
        if (!str) return '';
        var parts = str.split('-');
        return parseInt(parts[2], 10) + ' ' + MONTHS[parseInt(parts[1], 10) - 1];
    }

    function renderPoll(poll) {
        var segments = PARTY_KEYS
            .map(function (k) { return { key: k, pct: poll[k] || 0, meta: PARTY_META[k] }; })
            .filter(function (s) { return s.pct > 0; })
            .sort(function (a, b) { return b.pct - a.pct; });

        if (!segments.length) return '';

        var total = segments.reduce(function (acc, s) { return acc + s.pct; }, 0);
        var pollster = escapeHtml((poll.pollster && poll.pollster.name) || '');
        var client   = escapeHtml((poll.client   && poll.client.name)   || '');
        var byline   = client ? pollster + ' / ' + client : pollster;

        var bars = segments.map(function (s, i) {
            var w = ((s.pct / total) * 100).toFixed(3);
            var label = i === 0
                ? '<span class="ukpr-poll-sid-leader" style="color:' + s.meta.text + ';opacity:0">'
                    + escapeHtml(s.meta.label) + ' ' + s.pct + '%</span>'
                : '';
            return '<div class="ukpr-poll-sid-seg" style="width:' + w + '%;background:' + s.meta.color + ';">'
                + label + '</div>';
        }).join('');

        return [
            '<div class="ukpr-poll-sid-item">',
            '  <div class="ukpr-poll-sid-head">',
            '    <span class="ukpr-poll-sid-pollster" title="' + byline + '">' + byline + '</span>',
            '    <span class="ukpr-poll-sid-date">' + fmtDate(poll.from) + '</span>',
            '  </div>',
            '  <div class="ukpr-poll-sid-bar">' + bars + '</div>',
            '</div>'
        ].join('');
    }

    function animateIn(items) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reducedMotion) {
            items.forEach(function (item) {
                var bar    = item.querySelector('.ukpr-poll-sid-bar');
                var leader = item.querySelector('.ukpr-poll-sid-leader');
                if (bar)    bar.style.clipPath = 'none';
                if (leader) leader.style.opacity = '1';
            });
            return;
        }

        // Collapse all bars before they're visible
        items.forEach(function (item) {
            var bar = item.querySelector('.ukpr-poll-sid-bar');
            if (bar) bar.style.clipPath = 'inset(0 100% 0 0)';
        });

        // Double rAF ensures collapsed state is painted before transitions start
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                items.forEach(function (item, i) {
                    var bar = item.querySelector('.ukpr-poll-sid-bar');
                    if (!bar) return;
                    var dur = ((DURATIONS[i] || 600) / 1000).toFixed(1);
                    var del = ((DELAYS[i]    || 0)   / 1000).toFixed(1);
                    bar.style.transition = 'clip-path ' + dur + 's ease ' + del + 's';
                    bar.style.clipPath   = 'inset(0 0% 0 0)';
                });

                // Fade in leader labels once all bars have completed
                setTimeout(function () {
                    items.forEach(function (item) {
                        var leader = item.querySelector('.ukpr-poll-sid-leader');
                        if (leader) {
                            leader.style.transition = 'opacity 160ms ease';
                            leader.style.opacity    = '1';
                        }
                    });
                }, 1500);
            });
        });
    }

    function initPollSidebar(root) {
        var container = root.querySelector('[data-polls-sidebar-items]');
        if (!container) return;

        fetch('https://pollingreport.uk/api/v1/polls?latest=true&limit=4', { credentials: 'omit' })
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function (payload) {
                var polls = ((payload && payload.data) || []).slice(0, 4);
                if (!polls.length) {
                    container.innerHTML = '<p class="ukpr-home-polls-status">No polls available.</p>';
                    return;
                }
                container.innerHTML = polls.map(renderPoll).join('');
                var items = Array.prototype.slice.call(container.querySelectorAll('.ukpr-poll-sid-item'));
                animateIn(items);
            })
            .catch(function () {
                container.innerHTML = '<p class="ukpr-home-polls-status">Poll data unavailable.</p>';
            });
    }

    roots.forEach(initPollSidebar);
})();
